import Reveal from "../Reveal";

export default function Atelier({ settings }) {
  if (!settings) return null;
  return (
    <section id="atelier" data-testid="atelier" style={{ padding: "7rem 0", background: "var(--fs-bg)" }}>
      <div className="fs-container grid md:grid-cols-12 gap-10 md:gap-16 items-center">
        <Reveal className="md:col-span-5">
          <div
            style={{
              position: "relative",
              border: "1px solid var(--fs-caramel-line)",
              overflow: "hidden",
              aspectRatio: "3/4",
              background: "var(--fs-surface-alt)",
            }}
          >
            <img
              src={settings.atelier_image_url}
              alt="Rhon Friend, founder"
              data-testid="atelier-image"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          </div>
        </Reveal>

        <Reveal className="md:col-span-7" delay={120}>
          <p className="fs-overline" data-testid="atelier-overline">{settings.atelier_overline}</p>

          <h2 className="fs-display-2" style={{ marginTop: "1rem", marginBottom: "2rem" }} data-testid="atelier-title">
            {settings.atelier_title_line1}<br />
            <span className="fs-ital">{settings.atelier_title_italic}</span>
          </h2>

          <p style={{ color: "var(--fs-ink-soft)", fontSize: "1.05rem", lineHeight: 1.8, marginBottom: "1.5rem", maxWidth: "640px" }}>
            {settings.atelier_paragraph_1}
          </p>
          <p style={{ color: "var(--fs-ink-soft)", fontSize: "1.05rem", lineHeight: 1.8, maxWidth: "640px" }}>
            {settings.atelier_paragraph_2}
          </p>

          <hr className="fs-hairline" />

          <p
            data-testid="atelier-quote"
            style={{
              fontFamily: "'Playfair Display', serif",
              fontStyle: "italic",
              fontSize: "clamp(1.25rem, 2vw, 1.7rem)",
              color: "var(--fs-caramel)",
              lineHeight: 1.4,
              maxWidth: "640px",
            }}
          >
            “{settings.atelier_quote}”
          </p>
        </Reveal>
      </div>
    </section>
  );
}
